export const tabs = [
  { id: "1", title: "Project Overview" },
  { id: "2", title: "Inclusions" },
  { id: "3", title: "Comission Details" },
];
export default tabs;

export const statusStyleArray = [
  {
    status: "STANDARD",
    color: "#d46b08",
    backgroundColor: "#fff7e6",
  },
  {
    status: "ECONOMIC",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
  {
    status: "HIGH END",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "SUPER HIGH END",
    color: "#389e0d",
    backgroundColor: "#f6ffed",
  },
  {
    status: "SUBMITTED",
    backgroundColor: "#096dd9",
    color: "#e6f7ff",
  },
  {
    status: "awaiting-contractor-confirmation",
    color: "#d4b106",
    backgroundColor: "#feffe6",
  },
  {
    status: "awaiting-package-pricing",
    backgroundColor: "#d46b08",
    color: "#fff7e6",
  },
  {
    status: "approved",
    color: "#fff",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "CREATED",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "UPDATED",
    color: "#096dd9",
    backgroundColor: "#e6f7ff",
  },
];

export const milestoneStatusStyleArray = [
  {
    status: "ongoing",
    backgroundColor: "#096dd9",
  },
  {
    status: "Not Started",
    color: "#c41d7f",
    backgroundColor: "#fff0f6",
  },
  {
    status: "delivered",
    backgroundColor: "#389e0d",
  },
  {
    status: "pending",
    backgroundColor: "#d46b08",
  },
  {
    status: "completed",
    backgroundColor: "rgb(56, 158, 13)",
  },
  { status: "change_request", backgroundColor: "#c41d7f" },
  { status: "due", backgroundColor: "#c41d7f" },
  { status: "closed", backgroundColor: "red" },
];

export const paymentStatusStyleArray = [
  {
    status: "INITIATED",
    backgroundColor: "#096dd9",
  },
  {
    status: "completed",
    backgroundColor: "#389e0d",
  },
  {
    status: "Not Started",
    backgroundColor: "#fff7e6",
  },
  {
    status: "PAID",
    backgroundColor: "rgb(56, 158, 13)",
  },
  {
    status: "delivered",
    backgroundColor: "#389e0d",
  },
  {
    status: "CREATED",
    backgroundColor: "#c41d7f",
  },
];
